import { render, staticRenderFns } from "./LocationAsset.vue?vue&type=template&id=2d4058be"
import script from "./LocationAsset.vue?vue&type=script&lang=js"
export * from "./LocationAsset.vue?vue&type=script&lang=js"
import style0 from "./LocationAsset.vue?vue&type=style&index=0&id=2d4058be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports